module.exports = __webpack_public_path__ + "img/checkmark_disabled.8a006947.svg";